export default "__VITE_ASSET__faf3a27f__"